import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardComponentComponent } from './card-layout-component/card-layout-component.component';

@NgModule({
  declarations: [
    CardComponentComponent
  ],
  exports:[
    CardComponentComponent
  ],
  imports: [
    CommonModule
  ]
})

export class CardModuleModule { }
